import { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, X, ArrowRight, Loader2 } from 'lucide-react';
import api from '@/api';

const WHATSAPP_NUMBER = '15559021743';
const WHATSAPP_MESSAGE = "Hey! I just signed up for WTFHappened. Send me today's trending topics!";

export default function WhatsAppPrompt({ userName, isSubscribed, onDismiss }) {
  const [loading, setLoading] = useState(false);
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  const handleSubscribe = async () => {
    setLoading(true);
    try {
      const res = await api.createCheckout(window.location.origin);
      if (res.url) window.location.href = res.url;
    } catch (e) {
      console.error('Checkout failed:', e);
      setLoading(false);
    }
  };

  return (
    <motion.div
      data-testid="whatsapp-prompt"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="w-full max-w-xs mx-6 rounded-3xl overflow-hidden shadow-2xl"
        style={{ background: '#1a1a1a', border: '1px solid rgba(255,255,255,0.1)' }}
      >
        <div className="relative px-6 pt-6 pb-5">
          <button data-testid="whatsapp-dismiss" onClick={onDismiss}
            className="absolute top-4 right-4 w-7 h-7 rounded-full flex items-center justify-center transition-colors"
            style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <X size={14} style={{ color: '#e5e5e5' }} />
          </button>

          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center">
              <MessageCircle size={28} className="text-white" />
            </div>
          </div>

          <h3 className="text-lg font-black text-center leading-snug mb-1" style={{ color: '#f5f5f5' }}>
            {isSubscribed ? 'WhatsApp Unlocked!' : 'Get daily HOT TIPS on Whatsapp!'}
          </h3>
          {isSubscribed ? (
            <p className="text-sm text-center mb-6" style={{ color: '#a1a1aa' }}>
              Get daily HOT TIPS on WhatsApp
            </p>
          ) : (
            <p className="text-sm text-center mb-6" style={{ color: '#a1a1aa' }}>
              This also gives you access to all the Premium Sections
            </p>
          )}

          <div className="space-y-3">
            {isSubscribed ? (
              <a data-testid="whatsapp-connect-btn" href={waLink} target="_blank" rel="noopener noreferrer"
                className="w-full py-3.5 rounded-2xl bg-[#25D366] text-white text-sm font-bold
                  flex items-center justify-center gap-2 hover:bg-[#20bd5a] transition-all active:scale-[0.98]">
                <MessageCircle size={18} /> Open WhatsApp <ArrowRight size={16} />
              </a>
            ) : (
              <button data-testid="whatsapp-subscribe-btn" onClick={handleSubscribe} disabled={loading}
                className="w-full py-3.5 rounded-2xl text-sm font-bold flex items-center justify-center gap-2
                  transition-all active:scale-[0.98] disabled:opacity-60 text-white"
                style={{ background: 'linear-gradient(to right, #F97316, #EC4899, #8B5CF6)' }}>
                {loading ? <Loader2 size={18} className="animate-spin" /> : (
                  <>Subscribe <ArrowRight size={16} /></>
                )}
              </button>
            )}
            <button data-testid="whatsapp-skip-btn" onClick={onDismiss}
              className="w-full py-2.5 rounded-2xl text-sm font-semibold transition-colors"
              style={{ color: '#a1a1aa' }}>
              Maybe later
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}
